export default {
  "home": {
    "title": "Hey du hast es geschafft auf die MyBikeSetup WebApp zu kommen und was willst du jetzt hier?",
    "mainmessage": "Neben unserer <a href=\"https://play.google.com/store/apps/details?id=net.byte_welt.eagleeye.mybikesetup\" target=\"_blank\">Android App</a> gibt es jetzt auch diese WebApp. Da wir, naja ich, aktuell nur noch die Android pflegen gibt es für alle anderen Plattformen diese WebApp.<br><br>Wenn euer Browser mitspielt habt ihr die selben funktionen wie bei Google.Ihr könnt hier eure Konfigurationen anlegen, bearbeiten und speichern, dabei werden alle Daten lokal in eurem Browser gespeichert. Browser zu, Browser auf und die Daten sind noch da (außer der Browser macht Mist und räumt auf, naaaa Apple 😜).<br>Außerdem sollte die App auch ohne Internetverbindung lauffähig sein, außer ihr habt einen Safari .... <br>Aber ihr könnt wie bei Android auch die Daten aufm Server speichern lassen oder vom Android holen.",
    "initial_question": "Es gibt lokal keine Konfiguration, was soll passieren:<br>Hast du schon eine User ID, dann gib sie hier ein",
    "noconfig_answer": "Du hast nichts? Dann lass dir hier eine Beispielkonfiguration erzeugen",
    "existing_configmsg": "Oh es gibt hier eine Konfiguration, na dann auf get's.",
    "components": {
      "load_configuration": "Konfiguration laden",
      "create_new": "Neue erstellen"
    }
  },
  "menu": {
    "spring_calculator": "Federhärten Rechner",
    "spoke_calculator": "Speichenrechner"
  },
  "app": {
    "menu": {
      "clear_storage": "Speicher löschen",
      "refresh": "Aktualisieren",
      "bookmark": "Bookmark/Share",
      "save_toserver": "Auf Server speichern"
    },
    "dialog": {
      "store_title": "Auf Server speichern?",
      "store_msg": "Wenn du zustimmst, werden alle Konfigurationen auf einem Server gespeichert und können über die User ID erreicht werden.<br>Außer der Konfiguration werden keine weiteren Daten gespeichert. Um diese Daten wieder zu erreichen solltest du die User ID speichern, mit dieser kannst du die Konfiguration auf anderen Geräten synchronisieren. Wenn du nicht zustimmst bleiben die Daten lokal im Browser gespeichert und werden gelöscht wenn du den Browser Speicher löschst.",
      "delete_start": "Soll dieses",
      "delete_end": "wirklich gelöscht werden? ",
      "delete_title": "Lösche",
    }
  },
  "todo": {
    "addfab": "ToDo hinzufügen",
    "editbtn": "ToDo bearbeiten",
    "dialog": {
      "edittitle": "ToDo Bearbeiten",
      "newtitle": "Neues ToDo",
    }
  },
  "setup": {
    "setuptitle": "Setup Titel",
    "menu": {},
    "setupitem": {
      "selecttype": "Typ auswählen",
    }
  },
  "calc": {
    "title": "Federhärten Rechner",
    "topmsg": "Um die Federhärte zu berechnen musst du uns mir ein paar Details verraten. Das Ergebnis ist eine berechnete Empfehlung, welche durch die persönlichen Vorlieben und deinem Rad abweichen kann. Wenn du ein schweres Rad, wie z.B. ein E-Bike fährst, dann solltest du zusätzliches Gewicht, in Abhhängigkeit von Motor und Batterie (3-8kg) mit einbeziehen.",
    "riderweight": "Fahrergewicht",
    "shockstroke": "Hub",
    "wheeltravel": "Federweg",
    "singlepivot_title": "Eingelenker/DW-Link",
    "vpp_title": "Viergelenker/VPP/4 Link",
    "results": "Ergebnis",
    "sag": {
      "label": "Sag",
      "plush": "Weich",
      "firm": "Straff"
    }
  },
  "setuptype": {
    "pressure": "Druck",
    "spring": "Feder",
    "tire_front": "Reifen vorn",
    "tire_rear": "Reifen hinten",
    "pressure_front": "Druck vorn",
    "pressure_rear": "Druck hinten",
    "chainring": "Kettenblatt"
  },
  "inprint": {"title": "Impressum"},
  "errormsg": {
    "minlength": "Mindestlänge 3 Zeichen",
    "required": "Die Eingabe ist erforderlich"
  },
  "spoke": {
    "title": "Speichenrechner",
    "hub_title": "Nabe",
    "hub_manufacturers_select": "Hersteller",
    "hub_select_title": "Modell",
    "rim_title": "Felge",
    "rim_manufacturers_select": "Hersteller",
    "rim_select_title": "Modell",
    "hub_rear": "hinten",
    "hub_front": "vorn",
    "result_title": "Ergebnis",
    "spoke_count": "Speichenanzahl",
    "spoke_crossing": "Kreuzungen",
    "spoke_length_left": "Speichenlänge links:",
    "spoke_length_right": "Speichenlänge rechts:",
    "exact": "exakt",
    "recommended": "empfohlen"
  },
  "noDataText": "Keine Daten verfügbar",
  "agree": "Zustimmen",
  "disagree": "Nix da",
  "ok": "OK",
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "fork": "Gabel",
  "shock": "Dämpfer",
  "misc": "Div",
  "add_bike": "Bike hinzufügen",
  "edit": "Bearbeiten",
  "new": "Neues",
  "duplicate_setup": "Setup duplizieren",
  "delete_setup": "Setup löschen",
  "rename_setup": "Setup umbennen",
  "delete_bike": "Bike löschen",
  "edit_bike": "Bike bearbeiten",
  "edit_setup": "Setup bearbeiten",
  "new_setup": "Neues Setup",
  "save": "Speichern",
  "dataIterator": {
    "prevPage": "<",
    "nextPage": ">",
    "pageText": "{0}-{1} von {2}",
    "rowsPerPageAll": "All"
  },
  "dataTable": {
    "rowsPerPageText": "Zeilen"
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/locale/de.ts
// module id = 74
// module chunks = 9